import { useTheme } from '@pushpay/theming';
export function useIllustrationBackgroundColor(background = 'grey') {
  const theme = useTheme();
  const backgroundColor = background === 'grey' ? theme.colors['palette-grey-light-400'] : theme.colors['palette-white'];
  return backgroundColor;
}